import { render, staticRenderFns } from "./ManualProtesto.vue?vue&type=template&id=ca9189ae"
import script from "./ManualProtesto.vue?vue&type=script&lang=js"
export * from "./ManualProtesto.vue?vue&type=script&lang=js"
import style0 from "./ManualProtesto.vue?vue&type=style&index=0&id=ca9189ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports